import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSearchResults, widget, WidgetDataType } from '@sitecore-search/react';
import PopularSearchCard from '../../components/popular-search-card/c-popular-search-card';
import GoogleIcon from '../../components/google-icon';
import { useSearchContext } from '../sitecore-search-block/components/search-provider/search-context';

const PopularSearchCarousel = () => {
    const swiperRef = useRef(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const { dataSource, popularSearchSorting, popularSearchMaxItems, currentKeyword } = useSearchContext();

    const {
        widgetRef,
        actions: { onKeyphraseChange },
        state: { keyphrase },
        queryResult: { data: { content: articles = [] } = {} }
    } = useSearchResults({
        query: query => {
            query.getRequest().setSources([dataSource]);
        },
        state: {
            sortType: popularSearchSorting,
            page: 1,
            itemsPerPage: popularSearchMaxItems,
            keyphrase: currentKeyword
        }
    });

    useEffect(() => {
        onKeyphraseChange({ keyphrase: currentKeyword });
    }, [currentKeyword, keyphrase, onKeyphraseChange]);

    if (articles.length === 0) {
        return null;
    }

    return (
        <div className="s-popular-search-carousel">
            <div className="section-header">
                <div className="container">
                    <p className="section-title">Popular search results for <span className="search-term">&quot;{currentKeyword}&quot;</span></p>
                </div>
            </div>

            <div ref={widgetRef} className="container carousel-container">
                <Swiper
                    slidesPerView={4}
                    spaceBetween={24}
                    onSwiper={swiper => {
                        swiperRef.current = swiper;
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    onSlideChange={swiper => {
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.2,
                            spaceBetween: 24,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        },
                        480: {
                            slidesPerView: 2.2,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        },
                        768: {
                            slidesPerView: 2.6,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        },
                        1170: {
                            slidesPerView: 4,
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0
                        }
                    }}
                    className="popular-search-swiper"
                >
                    {articles.map((article, index) => (
                        <SwiperSlide key={article.id}>
                            <PopularSearchCard
                                itemId={article.id}
                                itemIndex={index}
                                sourceId={dataSource}
                                title={article.title}
                                description={article.description}
                                cardImage={article.image_url}
                                link={{
                                    label: 'Read more',
                                    href: article.url
                                }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="container">
                <div className="carousel-nav">
                    <button
                        type="button"
                        className="btn-nav btn-prev"
                        onClick={() => {
                            swiperRef.current?.slidePrev();
                        }}
                        disabled={isBeginning}
                        aria-disabled={isBeginning ? 'true' : 'false'}
                    >
                        <GoogleIcon icon="arrow_back" />
                    </button>
                    <button
                        type="button"
                        className="btn-nav btn-next"
                        onClick={() => {
                            swiperRef.current?.slideNext();
                        }}
                        disabled={isEnd}
                        aria-disabled={isEnd ? 'true' : 'false'}
                    >
                        <GoogleIcon icon="arrow_forward" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default widget(PopularSearchCarousel, WidgetDataType.SEARCH_RESULTS, 'content');
